var _a;
import { IdAssetBundleProductionAnims } from "./IdAssetBundleProductionAnims";
export var assetBundleProductionAnims = (_a = {},
    _a[IdAssetBundleProductionAnims.Chicken] = require("../assets/spine/chicken/chicken.json"),
    _a[IdAssetBundleProductionAnims.Cow] = require("../assets/spine/cow/cow.json"),
    _a[IdAssetBundleProductionAnims.Dog] = require("../assets/spine/dog/dog.json"),
    _a[IdAssetBundleProductionAnims.Duck] = require("../assets/spine/duck/duck.json"),
    _a[IdAssetBundleProductionAnims.Goat] = require("../assets/spine/goat/Goat_big.json"),
    _a[IdAssetBundleProductionAnims.Goaty] = require("../assets/spine/goat/Goaty.json"),
    _a[IdAssetBundleProductionAnims.Pig] = require("../assets/spine/pig/pig.json"),
    _a[IdAssetBundleProductionAnims.Boy] = require("../assets/spine/citizens/boy/Farm_Boy.json"),
    _a[IdAssetBundleProductionAnims.Girl] = require("../assets/spine/citizens/girl/Farm_Girl.json"),
    _a[IdAssetBundleProductionAnims.Woman] = require("../assets/spine/citizens/woman/Farm_Lady.json"),
    _a[IdAssetBundleProductionAnims.Man] = require("../assets/spine/citizens/man/Farm_Guy.json"),
    _a[IdAssetBundleProductionAnims.WindmillBlades] = require("../assets/spine/windmill/windmill_blades.json"),
    _a[IdAssetBundleProductionAnims.MarketTruck] = require("../assets/spine/market_truck/market_truck.json"),
    _a[IdAssetBundleProductionAnims.MarketTruckDustTrail] = require("../assets/spine/market_truck/dust_trail.json"),
    _a[IdAssetBundleProductionAnims.BuildingCelebration3x3] = require("../assets/spine/building_construction/building_celebration_3x3.json"),
    _a[IdAssetBundleProductionAnims.BuildingCelebration3x6] = require("../assets/spine/building_construction/building_celebration_3x6.json"),
    _a[IdAssetBundleProductionAnims.BuildingCelebration6x6] = require("../assets/spine/building_construction/building_celebration_6x6.json"),
    _a[IdAssetBundleProductionAnims.BuildingCelebration6x9] = require("../assets/spine/building_construction/building_celebration_6x9.json"),
    _a[IdAssetBundleProductionAnims.BuildingCelebration9x9] = require("../assets/spine/building_construction/building_celebration_9x9.json"),
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/assetBundleProductionAnims.ts
// module id = 1737
// module chunks = 3